
import './App.css';
import AdManager from './Components/AdManager/AdManager';
import Billing from './Components/Billing/Billing';
import CreateAcount from './Components/CreateAcount/CreateAcount';
import DetailAccount from './Components/DetailAccount/DetailAccount';
import Home from './Components/Home/Home';
import Intro from './Components/Intro/Intro';
import Login from './Components/Login/Login';
import Navbar from './Components/Navbar/Navbar';
import { Routes, Route } from "react-router-dom"
import AdManagerRunning from './Components/AdManagerRunning/AdManagerRunning';
import MakePayment from './Components/MakePayment/MakePayment';
import CompanyList from './Components/CompanyList/CompanyList';
import Aproval from './Components/Aproval/Aproval';
import CompainPeformance from './Components/CompainPerformance/CompainPeformance';
import CustomerPortal from './Components/CustomerPortalOverView/CustomerPortal';
import SetUpCompain from './Components/SetUpCompain/SetUpCompain';
import SetupCompain2 from './Components/SetupCompain2/SetupCompain2';


function App() {
  return (
    <>
      <Navbar />
      {/* <AdManagerRunning/> */}
      {/* <MakePayment/> */}
      {/* <CompanyList/> */}
      {/* <Aproval/> */}
      {/* <CompainPeformance/> */}
      {/* <CustomerPortal/> */}
      {/* <SetUpCompain/> */}
      {/* <SetupCompain2/> */}
      {/* <Intro/> */}
      {/* <CreateAcount/> */}
      {/* <Login /> */}
      <Routes>
        
         <Route path="/" element={<CreateAcount />} />
        <Route path="home" element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="admanager" element={<AdManager />} />
        <Route path="billing" element={<Billing />} />
        <Route path="detailaccount" element={<DetailAccount />} />
        <Route path="adManagerrunning" element={<AdManagerRunning />} />
        <Route path="companylist" element={<CompanyList />} />
        <Route path="aproval" element={<Aproval />} />
        <Route path="compainpeformance" element={<CompainPeformance />} />
        <Route path="customerportal" element={<CustomerPortal />} />  
        <Route path="setupcompain" element={<SetUpCompain/> } />
        <Route path="setupcompain2" element={<SetupCompain2/> } /> 
        <Route path="intro" element={<Intro/> } />  
        <Route path="makepayment" element={<MakePayment/> } />     
        {/* <CreateAcount/> */}
        {/* <Home/> */}
        {/* <DetailAccount/> */}
        {/* <Login/> */}
        {/* <AdManager/> */}
        {/* <Billing/> */}
      </Routes>
    </>
  );
}

export default App;
